import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ConfigurationService } from '@core/services';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  public configurationService = inject(ConfigurationService);

  readonly currentYear = new Date().getFullYear();
}
